import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

// Pages
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Chat from "@/pages/Chat";
import AutoChatbot from "@/pages/AutoChatbot";
import Cybersecurity from "@/pages/Cybersecurity";
import Accounting from "@/pages/Accounting";
import Legal from "@/pages/Legal";
import Pricing from "@/pages/Pricing";
import PricingNew from "@/pages/PricingNew";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Roadmap from "@/pages/Roadmap";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import RefundPolicy from "@/pages/RefundPolicy";
import ServiceQuality from "@/pages/ServiceQuality";
import Voice from "@/pages/Voice";
import Audio from "@/pages/Audio";
import Music from "@/pages/Music";
import Video from "@/pages/Video";
import ChatbotCapabilities from "@/pages/ChatbotCapabilities";
import AIModels from "@/pages/AIModels";
import Contact from "@/pages/Contact";
import AdminInvitations from "@/pages/AdminInvitations";
import AdminStats from "@/pages/AdminStats";
import AdminTestimonials from "@/pages/AdminTestimonials";
import AdminDiscountCodes from "@/pages/AdminDiscountCodes";
import QRInfo from "@/pages/QRInfo";
import Generate from "@/pages/Generate";
import SecurityPage from "@/pages/SecurityPage";
import ReferralTerms from "@/pages/ReferralTerms";
import MyReferrals from "@/pages/MyReferrals";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/pricing" element={<PricingNew />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="/service-quality" element={<ServiceQuality />} />
          <Route path="/chatbot-capabilities" element={<ChatbotCapabilities />} />
          <Route path="/ai-models" element={<AIModels />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/referral-terms" element={<ReferralTerms />} />
          <Route path="/pricing-old" element={<Pricing />} />
          
          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat"
            element={
              <ProtectedRoute>
                <Chat />
              </ProtectedRoute>
            }
          />
          <Route
            path="/autochatbot"
            element={
              <ProtectedRoute>
                <AutoChatbot />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cybersecurity"
            element={
              <ProtectedRoute>
                <Cybersecurity />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting"
            element={
              <ProtectedRoute>
                <Accounting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/legal"
            element={
              <ProtectedRoute>
                <Legal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/voice"
            element={
              <ProtectedRoute>
                <Voice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/audio"
            element={
              <ProtectedRoute>
                <Audio />
              </ProtectedRoute>
            }
          />
          <Route
            path="/music"
            element={
              <ProtectedRoute>
                <Music />
              </ProtectedRoute>
            }
          />
          <Route
            path="/video"
            element={
              <ProtectedRoute>
                <Video />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/invitations"
            element={
              <ProtectedRoute>
                <AdminInvitations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/stats"
            element={
              <ProtectedRoute>
                <AdminStats />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/testimonials"
            element={
              <ProtectedRoute>
                <AdminTestimonials />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/discounts"
            element={
              <ProtectedRoute>
                <AdminDiscountCodes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/referrals"
            element={
              <ProtectedRoute>
                <MyReferrals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/generate"
            element={
              <ProtectedRoute>
                <Generate />
              </ProtectedRoute>
            }
          />
          <Route path="/qr-info" element={<QRInfo />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
